import React, { useState, useEffect } from "react";
import { fetchCalendarVideos, addVideoToDate } from "../../../network/service";
import { toast } from "react-toastify";
import Translate from "../../../Components/Multilanguage/Translate";
import { useTranslateText } from "../../../Components/Multilanguage/Translate";

function formatDateForApi(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

const AddVideoModal = ({ appInfo, date, onClose, onVideoAdded }) => {
  const [videos, setVideos] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const translateText = useTranslateText();

  const fetchVideos = async (key = "") => {
    setLoading(true);
    try {
      const res = await fetchCalendarVideos(appInfo, key);
      setVideos(res?.data?.data || []);
    } catch {
      setVideos([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchVideos();
  }, []);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    fetchVideos(e.target.value);
  };

  const handleAdd = async (videoId) => {
    try {
      const res = await addVideoToDate(appInfo, videoId, formatDateForApi(date));
      
      if (res?.data?.success) {
        toast.success(<Translate textKey="video_added" />);
        if (onVideoAdded) onVideoAdded();
      } else {
        toast.info(res?.message || <Translate textKey={"video_add_failed"} />);
      }
    } catch (err) {
      toast.error(<Translate textKey={"video_add_failed"} />);
    }
  };

  return (
    <div className="add-video-modal-backdrop">
      <div className="add-video-modal">
        <div className="modal-header">
          <h2><Translate textKey={"choose_video"} /></h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="search-input-wrapper">
        <span className="search-icon" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
              <circle cx="9" cy="9" r="7" stroke="currentColor" strokeWidth="2"/>
              <line x1="14.5" y1="14.5" x2="18" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </span>
          <input
            type="text"
            placeholder={translateText("search_videos") || "Search videos..."}
            value={search}
            onChange={handleSearch}
            className="search-input"
          />
        </div>
        <div className="video-list">
            {loading ? (
                       <div className="loader">
                       <div className="loader-spinner"></div>
                     </div>
            ) : videos.length === 0 ? (
                <div className="no-videos"><Translate textKey={"no_videos_found"} /></div>
            ) : (
            videos.map((video) => (
              <div
                className="video-item"
                key={video.video_id}
                onClick={() => handleAdd(video.video_id)}
              >
                <img src={video.thumbnail} alt={video?.video_title} />
                <div className="video-info">
                  <div className="video-title">{video?.video_title}</div>
                  {/* <div className="video-description">{video?.video_description}</div> */}
                  <div className="video-duration">{video.duration}</div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default AddVideoModal;